import { DataContractTct, GetInvestorDraftInstanceRes } from '@dealstack/shared/lib/generated';

export const buildInitialContractsChecked = (
	contracts: DataContractTct[],
	loadedInvestors: GetInvestorDraftInstanceRes[] | undefined,
	hasUploadedInvestors: boolean
): Map<string, Set<string>> => {
	if (!loadedInvestors?.length || hasUploadedInvestors) {
		return new Map(contracts.map((contract) => [contract.id, new Set()]));
	}
	return new Map(
		contracts.map((contract) => [
			contract.id,
			new Set(
				loadedInvestors.flatMap((investor) =>
					investor.contracts
						.filter((investorContract) => investorContract.id === contract.id)
						.map(() => investor.email)
				)
			),
		])
	);
};
